import { render, staticRenderFns } from "./AsCounter.vue?vue&type=template&id=07f5d9e7&scoped=true"
import script from "./AsCounter.vue?vue&type=script&lang=js"
export * from "./AsCounter.vue?vue&type=script&lang=js"
import style0 from "./AsCounter.vue?vue&type=style&index=0&id=07f5d9e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f5d9e7",
  null
  
)

export default component.exports